import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./CustomFieldsPage')).CustomFieldsPage,
  'customFieldsPage',
);
